import type { QueryKeyData, QueryParams } from '@pba/react-query';
import { type CommunityDetail, createCommunityDetail } from '#models';
import { useQuery } from '#query';
import { type CommunityDetailQueryFilter, getCommunityDetailQueryKey } from '#query-keys/communities';
import { getCommunity } from '../services';

export type CommunityDetailQueryData = QueryKeyData<CommunityDetail, typeof getCommunityDetailQueryKey>;

export type GetCommunityDetailParams = {
  id: string;
} & QueryParams<CommunityDetailQueryData, CommunityDetailQueryFilter>;

export const useCommunityQuery = ({ filter, id, options }: GetCommunityDetailParams) =>
  useQuery({
    async queryFn() {
      const { data } = await getCommunity({
        config: {
          params: {
            /* eslint-disable @typescript-eslint/naming-convention -- required by backend API */
            invitation_token: filter.invitationToken,
            /* eslint-enable @typescript-eslint/naming-convention -- required by backend API */
          },
        },
        routeParams: { id },
      });

      return createCommunityDetail(data);
    },
    queryKey: getCommunityDetailQueryKey({
      filter: { invitationToken: filter.invitationToken },
      id,
    }),
    refetchOnMount: filter.invitationToken ? 'always' : undefined,
    ...options,
  });
